module.exports = {
	"metadata": {
		"formatVersion": 3.1,
		"sourceFile": "platonic_scaled.obj",
		"generatedBy": "OBJConverter",
		"vertices": 94,
		"faces": 184,
		"normals": 0,
		"colors": 0,
		"uvs": 45,
		"materials": 1
	},
	"scale": 1,
	"vertices": [
		-1.911614,
		2.245054,
		-1.611829,
		-3.169111,
		1.874807,
		-0.870641,
		-1.155314,
		3.249996,
		-0.554269,
		-1.609733,
		3.304866,
		1.128349,
		0.03689,
		3.333659,
		2.180968,
		0.025859,
		5.720659,
		-0.033705,
		-0.734306,
		4.894357,
		-0.001887,
		-0.151431,
		-2.323506,
		-2.89213,
		1.350217,
		-2.306339,
		-1.640411,
		0.025261,
		-3.321279,
		-2.133223,
		-0.719369,
		-4.036309,
		-0.810213,
		0.023952,
		-4.30954,
		-1.159952,
		-0.544507,
		2.318355,
		2.315855,
		-0.112306,
		-0.166158,
		-5.761741,
		0.939776,
		-0.572023,
		-4.516016,
		5.232015,
		0,
		-1.037738,
		5.241986,
		0.416023,
		-0.055343,
		4.553796,
		-0.961251,
		0.445674,
		-4.566758,
		-0.62966,
		-0.06409,
		-1.779554,
		-1.448046,
		-2.15525,
		-3.518763,
		-2.600577,
		-0.121852,
		-1.138536,
		-1.825798,
		-2.86842,
		-3.133519,
		0.402935,
		-1.104216,
		-4.23688,
		0.74165,
		-0.74165,
		0.399232,
		-3.148714,
		-1.09796,
		-3.344659,
		0.001998,
		-2.472236,
		-1.587758,
		1.192801,
		-3.021365,
		-1.473195,
		0.059117,
		-4.268866,
		0.013389,
		-1.003095,
		4.670049,
		0.701455,
		-0.844134,
		3.784775,
		0.220268,
		0.007124,
		5.64431,
		-2.953374,
		2.665179,
		0.071647,
		1.87311,
		-2.194542,
		1.177047,
		3.157824,
		-1.711131,
		0.768587,
		2.735985,
		-1.543058,
		1.94088,
		-0.003244,
		2.442722,
		3.835477,
		-0.57458,
		1.084268,
		-3.523588,
		0.151305,
		0.318973,
		-4.964394,
		-1.667689,
		1.871283,
		1.720658,
		-1.294482,
		-1.442383,
		3.012832,
		-2.032463,
		-1.885492,
		2.341059,
		-0.092402,
		-3.563136,
		1.47376,
		3.611115,
		1.238863,
		-0.546929,
		-2.380467,
		-2.99008,
		0.008618,
		-1.692423,
		-4.528464,
		0.027979,
		-2.339927,
		-2.096264,
		0.56738,
		-0.071419,
		2.398431,
		-3.208238,
		0.021626,
		3.367586,
		-2.181669,
		-0.635986,
		1.121784,
		3.666301,
		-0.020186,
		1.051048,
		4.570847,
		-1.797284,
		1.263459,
		2.998429,
		-2.303878,
		0.790608,
		2.00936,
		0.076033,
		-2.61111,
		2.784263,
		-3.011963,
		1.613871,
		1.613871,
		-3.11653,
		1.019392,
		0.320346,
		-3.769426,
		1.524067,
		-0.092905,
		0.999134,
		-1.560676,
		-3.121949,
		1.077816,
		-2.807022,
		2.217689,
		0.015908,
		1.451518,
		-4.33307,
		-1.552801,
		0.027321,
		3.855533,
		2.628827,
		-1.94061,
		-0.920988,
		2.206197,
		-1.949374,
		-1.90067,
		2.968488,
		-0.577451,
		-1.412337,
		3.189493,
		0.162708,
		1.966635,
		4.237708,
		0,
		1.441524,
		-4.545804,
		0.009383,
		1.365527,
		-5.656841,
		0,
		0,
		-3.29805,
		0.046128,
		1.810234,
		-4.729902,
		1.113359,
		0.106048,
		-1.180831,
		-0.479222,
		3.138651,
		-0.983357,
		-0.000001,
		5.177633,
		1.875545,
		-0.196492,
		-3.064984,
		2.192634,
		-3.272266,
		-0.032457,
		2.033682,
		0.016055,
		3.493662,
		3.735267,
		-1.983425,
		-0.380458,
		0.789438,
		4.588195,
		-0.027799,
		-0.038068,
		-5.644819,
		-0.011269,
		0.021858,
		4.245992,
		-1.601848,
		2.179158,
		3.724905,
		0.017549,
		4.103035,
		-0.851841,
		-0.272917,
		-1.120544,
		-2.648617,
		-0.828581,
		2.374073,
		1.941273,
		0.965862,
		3.190802,
		2.092755,
		-0.019894,
		-3.096421,
		-0.79594,
		1.70024,
		2.171292,
		1.61088,
		2.204946,
		1.044368,
		1.480372,
		2.689116,
		3.782446,
		1.105007,
		0.960773,
		0.079828,
		-4.843222,
		0.811014,
		2.997784,
		0.043773,
		-2.802564,
		4.036233,
		-0.033969,
		-1.719838,
		-4.678792,
		-0.004584,
		-1.586769,
		1.876779,
		2.926686,
		-1.030287,
		1.656102,
		1.61078,
		-1.983222,
		1.959872,
		0.966628,
		-3.258484
	],
	"morphTargets": [],
	"morphColors": [],
	"normals": [],
	"colors": [],
	"uvs": [
		[
			0.4375,
			0.875,
			0.5625,
			0.875,
			0.5,
			1,
			0.5,
			0.75,
			0.625,
			0.75,
			0.375,
			0.75,
			0.5625,
			0.625,
			0.6875,
			0.625,
			0.4375,
			0.625,
			0.3125,
			0.625,
			0.625,
			0.5,
			0.75,
			0.5,
			0.5,
			0.5,
			0.375,
			0.5,
			0.25,
			0.5,
			0.6875,
			0.375,
			0.8125,
			0.375,
			0.5625,
			0.375,
			0.4375,
			0.375,
			0.3125,
			0.375,
			0.1875,
			0.375,
			0.75,
			0.25,
			0.875,
			0.25,
			0.625,
			0.25,
			0.5,
			0.25,
			0.375,
			0.25,
			0.25,
			0.25,
			0.125,
			0.25,
			0.8125,
			0.125,
			0.9375,
			0.125,
			0.6875,
			0.125,
			0.5625,
			0.125,
			0.4375,
			0.125,
			0.3125,
			0.125,
			0.1875,
			0.125,
			0.0625,
			0.125,
			0.875,
			0,
			1,
			0,
			0.75,
			0,
			0.625,
			0,
			0.5,
			0,
			0.375,
			0,
			0.25,
			0,
			0.125,
			0,
			0,
			0
		]
	],
	"faces": [
		10,
		0,
		1,
		2,
		0,
		0,
		1,
		2,
		10,
		3,
		4,
		5,
		0,
		3,
		4,
		1,
		10,
		5,
		6,
		3,
		0,
		1,
		0,
		3,
		10,
		7,
		8,
		9,
		0,
		5,
		3,
		0,
		10,
		10,
		9,
		11,
		0,
		6,
		7,
		4,
		10,
		4,
		3,
		12,
		0,
		4,
		3,
		6,
		10,
		13,
		14,
		7,
		0,
		8,
		6,
		3,
		10,
		15,
		16,
		17,
		0,
		3,
		5,
		8,
		10,
		18,
		19,
		20,
		0,
		9,
		8,
		5,
		10,
		9,
		10,
		21,
		0,
		10,
		11,
		7,
		10,
		22,
		23,
		1,
		0,
		7,
		6,
		10,
		10,
		9,
		24,
		11,
		0,
		12,
		10,
		6,
		10,
		25,
		26,
		27,
		0,
		6,
		8,
		12,
		10,
		28,
		29,
		30,
		0,
		13,
		12,
		8,
		10,
		3,
		6,
		31,
		0,
		8,
		9,
		13,
		10,
		32,
		33,
		34,
		0,
		14,
		13,
		9,
		10,
		12,
		35,
		4,
		0,
		15,
		16,
		11,
		10,
		36,
		37,
		27,
		0,
		11,
		10,
		15,
		10,
		13,
		27,
		37,
		0,
		17,
		15,
		10,
		10,
		12,
		3,
		38,
		0,
		10,
		12,
		17,
		10,
		39,
		40,
		41,
		0,
		18,
		17,
		12,
		10,
		3,
		31,
		38,
		0,
		12,
		13,
		18,
		10,
		42,
		16,
		15,
		0,
		19,
		18,
		13,
		10,
		43,
		44,
		45,
		0,
		13,
		14,
		19,
		10,
		46,
		0,
		47,
		0,
		20,
		19,
		14,
		10,
		48,
		49,
		35,
		0,
		21,
		22,
		16,
		10,
		35,
		12,
		48,
		0,
		16,
		15,
		21,
		10,
		50,
		48,
		12,
		0,
		23,
		21,
		15,
		10,
		12,
		38,
		50,
		0,
		15,
		17,
		23,
		10,
		51,
		50,
		38,
		0,
		24,
		23,
		17,
		10,
		41,
		52,
		39,
		0,
		17,
		18,
		24,
		10,
		53,
		51,
		38,
		0,
		25,
		24,
		18,
		10,
		38,
		31,
		53,
		0,
		18,
		19,
		25,
		10,
		54,
		53,
		31,
		0,
		26,
		25,
		19,
		10,
		31,
		55,
		54,
		0,
		19,
		20,
		26,
		10,
		8,
		7,
		56,
		0,
		27,
		26,
		20,
		10,
		57,
		32,
		34,
		0,
		28,
		29,
		22,
		10,
		37,
		36,
		58,
		0,
		22,
		21,
		28,
		10,
		32,
		57,
		41,
		0,
		30,
		28,
		21,
		10,
		48,
		50,
		59,
		0,
		21,
		23,
		30,
		10,
		60,
		61,
		62,
		0,
		31,
		30,
		23,
		10,
		63,
		17,
		64,
		0,
		23,
		24,
		31,
		10,
		34,
		33,
		63,
		0,
		32,
		31,
		24,
		10,
		65,
		66,
		18,
		0,
		24,
		25,
		32,
		10,
		67,
		51,
		53,
		0,
		33,
		32,
		25,
		10,
		53,
		54,
		67,
		0,
		25,
		26,
		33,
		10,
		68,
		67,
		54,
		0,
		34,
		33,
		26,
		10,
		54,
		55,
		68,
		0,
		26,
		27,
		34,
		10,
		69,
		28,
		59,
		0,
		35,
		34,
		27,
		10,
		70,
		30,
		49,
		0,
		36,
		37,
		29,
		10,
		49,
		48,
		70,
		0,
		29,
		28,
		36,
		10,
		59,
		70,
		48,
		0,
		38,
		36,
		28,
		10,
		28,
		39,
		52,
		0,
		28,
		30,
		38,
		10,
		14,
		71,
		56,
		0,
		39,
		38,
		30,
		10,
		32,
		72,
		33,
		0,
		30,
		31,
		39,
		10,
		67,
		59,
		50,
		0,
		40,
		39,
		31,
		10,
		50,
		51,
		67,
		0,
		31,
		32,
		40,
		10,
		28,
		69,
		39,
		0,
		41,
		40,
		32,
		10,
		52,
		34,
		73,
		0,
		32,
		33,
		41,
		10,
		74,
		33,
		72,
		0,
		42,
		41,
		33,
		10,
		67,
		68,
		65,
		0,
		33,
		34,
		42,
		10,
		17,
		63,
		33,
		0,
		43,
		42,
		34,
		10,
		70,
		59,
		28,
		0,
		34,
		35,
		43,
		10,
		66,
		65,
		68,
		0,
		44,
		43,
		35,
		10,
		61,
		56,
		71,
		0,
		0,
		1,
		2,
		10,
		9,
		8,
		24,
		0,
		3,
		4,
		1,
		10,
		75,
		5,
		4,
		0,
		1,
		0,
		3,
		10,
		72,
		32,
		76,
		0,
		5,
		3,
		0,
		10,
		6,
		77,
		2,
		0,
		6,
		7,
		4,
		10,
		75,
		4,
		78,
		0,
		4,
		3,
		6,
		10,
		62,
		79,
		74,
		0,
		8,
		6,
		3,
		10,
		74,
		60,
		62,
		0,
		3,
		5,
		8,
		10,
		2,
		31,
		6,
		0,
		9,
		8,
		5,
		10,
		20,
		19,
		80,
		0,
		10,
		11,
		7,
		10,
		79,
		33,
		74,
		0,
		7,
		6,
		10,
		10,
		81,
		82,
		78,
		0,
		12,
		10,
		6,
		10,
		78,
		4,
		81,
		0,
		6,
		8,
		12,
		10,
		77,
		6,
		5,
		0,
		13,
		12,
		8,
		10,
		71,
		62,
		61,
		0,
		8,
		9,
		13,
		10,
		18,
		83,
		65,
		0,
		14,
		13,
		9,
		10,
		45,
		41,
		40,
		0,
		15,
		16,
		11,
		10,
		80,
		43,
		20,
		0,
		11,
		10,
		15,
		10,
		83,
		69,
		67,
		0,
		17,
		15,
		10,
		10,
		80,
		21,
		10,
		0,
		10,
		12,
		17,
		10,
		19,
		18,
		25,
		0,
		18,
		17,
		12,
		10,
		81,
		4,
		84,
		0,
		12,
		13,
		18,
		10,
		85,
		84,
		4,
		0,
		19,
		18,
		13,
		10,
		67,
		65,
		83,
		0,
		13,
		14,
		19,
		10,
		35,
		85,
		4,
		0,
		20,
		19,
		14,
		10,
		86,
		42,
		82,
		0,
		21,
		22,
		16,
		10,
		82,
		81,
		86,
		0,
		16,
		15,
		21,
		10,
		63,
		86,
		81,
		0,
		23,
		21,
		15,
		10,
		59,
		67,
		69,
		0,
		15,
		17,
		23,
		10,
		84,
		63,
		81,
		0,
		24,
		23,
		17,
		10,
		20,
		83,
		18,
		0,
		17,
		18,
		24,
		10,
		21,
		80,
		19,
		0,
		25,
		24,
		18,
		10,
		76,
		87,
		44,
		0,
		18,
		19,
		25,
		10,
		21,
		19,
		27,
		0,
		26,
		25,
		19,
		10,
		43,
		80,
		44,
		0,
		19,
		20,
		26,
		10,
		21,
		7,
		9,
		0,
		27,
		26,
		20,
		10,
		86,
		16,
		42,
		0,
		28,
		29,
		22,
		10,
		1,
		55,
		31,
		0,
		22,
		21,
		28,
		10,
		20,
		45,
		83,
		0,
		30,
		28,
		21,
		10,
		31,
		2,
		1,
		0,
		21,
		23,
		30,
		10,
		63,
		73,
		34,
		0,
		31,
		30,
		23,
		10,
		41,
		44,
		87,
		0,
		23,
		24,
		31,
		10,
		73,
		63,
		84,
		0,
		32,
		31,
		24,
		10,
		84,
		85,
		73,
		0,
		24,
		25,
		32,
		10,
		0,
		46,
		26,
		0,
		33,
		32,
		25,
		10,
		85,
		35,
		73,
		0,
		25,
		26,
		33,
		10,
		17,
		79,
		15,
		0,
		34,
		33,
		26,
		10,
		35,
		49,
		73,
		0,
		26,
		27,
		34,
		10,
		8,
		72,
		24,
		0,
		35,
		34,
		27,
		10,
		62,
		71,
		88,
		0,
		36,
		37,
		29,
		10,
		60,
		74,
		72,
		0,
		29,
		28,
		36,
		10,
		64,
		16,
		86,
		0,
		38,
		36,
		28,
		10,
		61,
		60,
		72,
		0,
		28,
		30,
		38,
		10,
		63,
		64,
		86,
		0,
		39,
		38,
		30,
		10,
		1,
		0,
		22,
		0,
		30,
		31,
		39,
		10,
		22,
		0,
		26,
		0,
		39,
		31,
		40,
		10,
		44,
		41,
		45,
		0,
		31,
		32,
		40,
		10,
		79,
		62,
		89,
		0,
		41,
		40,
		32,
		10,
		7,
		21,
		27,
		0,
		32,
		33,
		41,
		10,
		36,
		26,
		46,
		0,
		42,
		41,
		33,
		10,
		89,
		15,
		79,
		0,
		33,
		34,
		42,
		10,
		68,
		23,
		90,
		0,
		43,
		42,
		34,
		10,
		73,
		49,
		30,
		0,
		34,
		35,
		43,
		10,
		30,
		70,
		28,
		0,
		44,
		43,
		35,
		10,
		75,
		77,
		5,
		0,
		0,
		1,
		2,
		10,
		73,
		29,
		52,
		0,
		3,
		4,
		1,
		10,
		23,
		68,
		55,
		0,
		1,
		0,
		3,
		10,
		88,
		89,
		62,
		0,
		5,
		3,
		0,
		10,
		75,
		47,
		77,
		0,
		6,
		7,
		4,
		10,
		90,
		66,
		68,
		0,
		4,
		3,
		6,
		10,
		56,
		7,
		14,
		0,
		8,
		6,
		3,
		10,
		55,
		1,
		23,
		0,
		3,
		5,
		8,
		10,
		78,
		91,
		75,
		0,
		9,
		8,
		5,
		10,
		73,
		30,
		29,
		0,
		10,
		11,
		7,
		10,
		56,
		61,
		8,
		0,
		7,
		6,
		10,
		10,
		91,
		47,
		75,
		0,
		12,
		10,
		6,
		10,
		69,
		83,
		40,
		0,
		6,
		8,
		12,
		10,
		40,
		83,
		45,
		0,
		13,
		12,
		8,
		10,
		40,
		39,
		69,
		0,
		8,
		9,
		13,
		10,
		82,
		91,
		78,
		0,
		14,
		13,
		9,
		10,
		23,
		22,
		90,
		0,
		15,
		16,
		11,
		10,
		46,
		47,
		92,
		0,
		11,
		10,
		15,
		10,
		16,
		64,
		17,
		0,
		17,
		15,
		10,
		10,
		47,
		91,
		92,
		0,
		10,
		12,
		17,
		10,
		77,
		0,
		2,
		0,
		17,
		12,
		18,
		10,
		10,
		44,
		80,
		0,
		12,
		13,
		18,
		10,
		14,
		13,
		37,
		0,
		19,
		18,
		13,
		10,
		47,
		0,
		77,
		0,
		13,
		14,
		19,
		10,
		34,
		52,
		57,
		0,
		20,
		19,
		14,
		10,
		33,
		79,
		17,
		0,
		21,
		22,
		16,
		10,
		46,
		92,
		58,
		0,
		16,
		15,
		21,
		10,
		29,
		28,
		52,
		0,
		23,
		21,
		15,
		10,
		27,
		13,
		7,
		0,
		15,
		17,
		23,
		10,
		57,
		52,
		41,
		0,
		24,
		23,
		17,
		10,
		76,
		11,
		24,
		0,
		17,
		18,
		24,
		10,
		11,
		76,
		10,
		0,
		25,
		24,
		18,
		10,
		22,
		26,
		25,
		0,
		18,
		19,
		25,
		10,
		42,
		92,
		91,
		0,
		26,
		25,
		19,
		10,
		91,
		82,
		42,
		0,
		19,
		20,
		26,
		10,
		90,
		25,
		18,
		0,
		27,
		26,
		20,
		10,
		15,
		89,
		42,
		0,
		28,
		29,
		22,
		10,
		26,
		36,
		27,
		0,
		22,
		21,
		28,
		10,
		32,
		41,
		87,
		0,
		30,
		28,
		21,
		10,
		66,
		90,
		18,
		0,
		21,
		23,
		30,
		10,
		25,
		27,
		19,
		0,
		31,
		30,
		23,
		10,
		58,
		92,
		93,
		0,
		23,
		24,
		31,
		10,
		88,
		93,
		92,
		0,
		32,
		31,
		24,
		10,
		44,
		10,
		76,
		0,
		24,
		25,
		32,
		10,
		89,
		88,
		92,
		0,
		33,
		32,
		25,
		10,
		92,
		42,
		89,
		0,
		25,
		26,
		33,
		10,
		25,
		90,
		22,
		0,
		34,
		33,
		26,
		10,
		87,
		76,
		32,
		0,
		26,
		27,
		34,
		10,
		24,
		72,
		76,
		0,
		35,
		34,
		27,
		10,
		72,
		8,
		61,
		0,
		36,
		37,
		29,
		10,
		58,
		36,
		46,
		0,
		29,
		28,
		36,
		10,
		14,
		37,
		58,
		0,
		38,
		36,
		28,
		10,
		58,
		93,
		14,
		0,
		28,
		30,
		38,
		10,
		71,
		14,
		93,
		0,
		39,
		38,
		30,
		10,
		45,
		20,
		43,
		0,
		30,
		31,
		39,
		10,
		88,
		71,
		93,
		0,
		40,
		39,
		31
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/3dobjects/platonic_scaled.json
// module id = 881
// module chunks = 0